module.exports = __webpack_public_path__ + "img/logo-white.9597ee62.svg";